import { createFileRoute } from '@tanstack/react-router';
import { assistantAPI } from '../../../../features/marketplace/services/api/assistantAPI';

export const Route = createFileRoute('/_app/assistant/update')({
  loader: async (ctx) => {
    return await ctx.context.queryClient.ensureQueryData({
      queryKey: ['personalAssistantFormConfiguration'],
      queryFn: () => assistantAPI.getAssistantCreationConfigurationAsync(),
      staleTime: Infinity,
    });
  },
});
